module.exports = {
  "version": "0.26.0"
};


//////////////////
// WEBPACK FOOTER
// ./~/axios/lib/env/data.js
// module id = 78
// module chunks = 0